import { SelectedHolidays } from './selected_holidays.js';

export const HolidayForDate = SelectedHolidays
    .reduce((map, e) => { map[e.d] = e; return map; }, {});
